import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { TenantProvider } from "./lib/tenant";
import { I18nProvider } from "./lib/i18n";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import OrgChart from "./pages/OrgChart";
import Directory from "./pages/Directory";
import PTOPage from "./pages/PTO";
import Reimbursements from "./pages/Reimbursements";
import Documents from "./pages/Documents";
import Approvals from "./pages/Approvals";
import Profile from "./pages/Profile";
import Admin from "./pages/Admin";
import Timesheet from "./pages/Timesheet";
import Hiring from "./pages/Hiring";
import Onboarding from "./pages/Onboarding";
import Offboarding from "./pages/Offboarding";
import Travel from "./pages/Travel";
import Loans from "./pages/Loans";
import Performance from "./pages/Performance";
import Trainings from "./pages/Trainings";
import Knowledge from "./pages/Knowledge";
import Planner from "./pages/Planner";
import DepartmentHub from "./pages/DepartmentHub";
import SalaryMatrix from "./pages/SalaryMatrix";
import Manual from "./pages/Manual";
import ManagerCockpit from "./pages/ManagerCockpit";
import QBOMapping from "./pages/QBOMapping";
import Copilot from "./pages/Copilot";
import SuperAdmin from "./pages/SuperAdmin";
import BrandingSettings from "./pages/BrandingSettings";
import Reports from "./pages/Reports";
import ServiceContracts from "./pages/ServiceContracts";
import { Toaster } from "sonner";

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <TenantProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/app"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/app/reimbursements" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="org-chart" element={<OrgChart />} />
              <Route path="directory" element={<Directory />} />
              <Route path="pto" element={<PTOPage />} />
              <Route path="planner" element={<Planner />} />
              <Route path="reimbursements" element={<Reimbursements />} />
              <Route path="travel" element={<Travel />} />
              <Route path="loans" element={<Loans />} />
              <Route path="performance" element={<Performance />} />
              <Route path="trainings" element={<Trainings />} />
              <Route path="departments" element={<DepartmentHub />} />
              <Route path="salary-matrix" element={<SalaryMatrix />} />
              <Route path="cockpit" element={<ProtectedRoute roles={["manager", "ceo", "hr", "admin"]}><ManagerCockpit /></ProtectedRoute>} />
              <Route path="admin/qbo-mapping" element={<ProtectedRoute roles={["hr", "admin"]}><QBOMapping /></ProtectedRoute>} />
              <Route path="service-contracts" element={<ProtectedRoute roles={["admin", "hr", "superadmin"]}><ServiceContracts /></ProtectedRoute>} />
              <Route path="manual" element={<Manual />} />
              <Route
                path="knowledge"
                element={
                  <ProtectedRoute roles={["admin", "hr", "manager", "ceo"]}>
                    <Knowledge />
                  </ProtectedRoute>
                }
              />
              <Route path="copilot" element={<Copilot />} />
              <Route path="documents" element={<Documents />} />
              <Route path="approvals" element={<Approvals />} />
              <Route path="reports" element={<Reports />} />
              <Route path="timesheet" element={<Timesheet />} />
              <Route path="onboarding" element={<Onboarding />} />
              <Route
                path="hiring"
                element={
                  <ProtectedRoute roles={["admin", "hr", "manager", "ceo"]}>
                    <Hiring />
                  </ProtectedRoute>
                }
              />
              <Route
                path="offboarding"
                element={
                  <ProtectedRoute roles={["admin", "hr", "manager", "ceo"]}>
                    <Offboarding />
                  </ProtectedRoute>
                }
              />
              <Route path="profile" element={<Profile />} />
              <Route
                path="admin"
                element={
                  <ProtectedRoute roles={["admin", "hr"]}>
                    <Admin />
                  </ProtectedRoute>
                }
              />
              <Route
                path="admin/branding"
                element={
                  <ProtectedRoute roles={["admin", "hr"]}>
                    <BrandingSettings />
                  </ProtectedRoute>
                }
              />
              <Route
                path="superadmin"
                element={
                  <ProtectedRoute roles={["superadmin"]}>
                    <SuperAdmin />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" />
        </BrowserRouter>
        </TenantProvider>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
